import { NotificationsInner, Position } from './notifications-inner';
import { NotificationsPortal } from './notifications-portal';

type NotificationsProps = {
  position: Position;
  max: number;
};

const Notifications = (props: NotificationsProps) => (
  <NotificationsPortal>
    <NotificationsInner {...props} />
  </NotificationsPortal>
);

Notifications.displayName = 'Notifications';

export { Notifications };
